module.exports = __webpack_public_path__ + "img/254.393fdb8f.png";